// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* Light 模式 */\n/* Color */\n/* Animation */\n/* Other */\n.version[data-v-7ba5bd90] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(23, 23, 23, 0.36);\n  font-size: 12px;\n  padding: 2px 10px;\n  border-radius: 10px 0 0 0;\n}", ""]);
// Exports
module.exports = exports;
